export default __webpack_public_path__ + "static/media/whatsappLight.7fff1c4f.png";